import styled from 'styled-components'
import { useState } from 'react';
import TabGroup from './common/TabGroup';
import Text from '../atoms/Text';
import Chart from 'react-apexcharts';
import { logEvent } from '../../utils/eventLogger';

const Container = styled.div`
  width: 100%;
  // padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 36px;
  // justify-content: center;
  // align-items: center;
  // background-color: ${(props) => props.theme.colors.neutral[100]};
  
`
const ChartWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 10px;
  // height: auto;
  position: relative;
  padding-top: 20px;
   .apexcharts-series path {
    // 바의 모양을 둥근 직사각형으로 강제 정의 (WebKit 전용)
    clip-path: inset(0% 0% 0% 0% round 12px 12px 0 0);
    -webkit-clip-path: inset(0% 0% 0% 0% round 12px 12px 0 0);
  }
`
const UnitText = styled(Text)`
  position: absolute;
  top: 16px;
  left: 16px;
`;
const GrowthTrendBoard = ({ data }) => {
  const [activeTab, setActiveTab] = useState('wordCount');

  const tabs = [
    { id: 'wordCount', label: '단어 수' },
    { id: 'conversationCount', label: '대화 수' },
    { id: 'conversationTime', label: '대화 시간' },
  ];

  const handleTabChange = (id) => {
    setActiveTab(id)

    // 로그 기록
    logEvent("report_view", { reportType: `trends-${id}` });
  };

  const chartSeries = [
    { data: data[activeTab] }
  ];

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: { enabled: false }
    },
    colors: ['#DDF2E5', '#BFEAD0', '#9BE5AE','#6FDC8A'],
    xaxis: {
      categories: ['3주 전', '2주 전', '1주 전', '이번 주'],
      labels: {
        style: {
          colors: ['#6D6F6D', '#6D6F6D', '#6D6F6D', '#000000'],
          fontSize: '14px',
          fontFamily: 'Pretendard, sans-serif',
          fontWeight: '400'
        }
      }
    },
    yaxis: {
      min: 0,
      // max: 250,
      tickAmount: 5,
        labels: {
          style: {
            colors: '#6D6F6D',
            fontSize: '12px',
            fontFamily: 'Pretendard, sans-serif',
            fontWeight: 400
          }
        }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 12, 
        borderRadiusApplication: 'end',
        distributed: true,
        dataLabels: { position: 'top' },
      },
    },
    tooltip: { enabled: false,},
    states: {
      hover: {
        filter: { type: 'none' },
      },
      active: {
        filter: { type: 'none' },
      },
    },
    dataLabels: {
      enabled: true,
      position: 'top',
      offsetY: -20,
      formatter: (val) => {
        // 데이터가 0이거나 null이면 빈 문자열을 반환해서 숫자를 숨김
        if (!val) return ''; 
        return val;
      },
      style: {
        fontSize: '12px',
        fontFamily: 'Pretendard, sans-serif',
        fontWeight: 400,
        colors: ['#9DA09D'],
      },
    },
    legend: { show: false },
  }
  
  return (
    <Container>
      <Text variant="headline2" weight="medium">누적 성장 추이</Text>
      <TabGroup
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleTabChange}
      />
      <ChartWrapper>
        {/* 대화 시간 탭일 때만 (분) 표시 */}
        {activeTab === 'conversationTime' && 
          <UnitText variant="caption" color="alternative">(분)</UnitText>}
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={350}
        />
      </ChartWrapper>
    </Container>
  )
}

export default GrowthTrendBoard
